import awsReinvent from './conferences/awsReinvent';
import sxswLondon2025 from './conferences/sxswLondon2025';
import sxswSydney2025 from './conferences/sxswSydney2025';
import { galleryBySlug } from '../../adventureGalleries';
import { adaptCorporateRetreat } from '../adaptCorporateRetreat';

const corporateRetreats = Object.values(galleryBySlug)
  .map((gallery) => adaptCorporateRetreat(gallery))
  .filter(Boolean);

export const reckonWayEvents = [
  awsReinvent,
  sxswLondon2025,
  sxswSydney2025,
  ...corporateRetreats,
];

export const reckonWayEventBySlug = reckonWayEvents.reduce((events, event) => ({
  ...events,
  [event.slug]: event,
}), {});
